import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=5b164156&"
import script from "./MyMessage.vue?vue&type=script&lang=js&"
export * from "./MyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports